import { Link } from 'react-router-dom'
import { EmptyState } from '@/components/ui/Feedback'

export default function NotFoundPage() {
  return (
    <EmptyState title="No encontramos esta página" description="El enlace pudo cambiar o el producto ya no está disponible.">
      <Link to="/perfil" className="ui-button" data-intent="primary" data-emphasis="solid">Ir a mi cuenta</Link>
    </EmptyState>
  )
}

